import * as React from 'react';

import { useNewPdDesignEnabled } from '@containers/ProductDetailContainer/ProductDetail/hooks/useNewPdDesignEnabled';

import { Description } from '../styled';

import { InstructionsWrapper, VideoWrapper, Video, PdfWrapper } from './styled';

interface IInstructionsProps {
  pdfLink: string;
  videoLink: string;
  instructions: string;
}

export const Instructions: React.FC<IInstructionsProps> = ({
  pdfLink,
  videoLink,
  instructions,
}) => {
  const newPdDesignEnabled = useNewPdDesignEnabled();
  return (
    <InstructionsWrapper newPdDesignEnabled={newPdDesignEnabled}>
      {instructions && (
        <Description
          newDesign={newPdDesignEnabled}
          style={{ marginTop: '0' }}
          dangerouslySetInnerHTML={{
            __html: instructions,
          }}
        />
      )}
      {pdfLink && (
        <PdfWrapper>
          <Description
            newDesign={newPdDesignEnabled}
            style={{ marginTop: '0' }}
            dangerouslySetInnerHTML={{
              __html: pdfLink,
            }}
          />
        </PdfWrapper>
      )}
      {videoLink && (
        <VideoWrapper>
          <Video
            src={videoLink}
            allow="encrypted-media"
            allowFullScreen={true}
          />
        </VideoWrapper>
      )}
    </InstructionsWrapper>
  );
};
